module.exports = __webpack_public_path__ + "static/media/loader.2acb9b4d.gif";